<template>
    <div>
        <nav class="pushy pushy-right" data-focus="#first-link">
            <div class="pushy-content">
                <p class="pushy-tit">전체메뉴</p>
                <p class="pushy-close">닫기</p>
                <ul>
                    <li class="pushy-link"><a id="first-link" :href="$cp">홈</a></li>
                    <li class="pushy-link"><a :href="$cp + 'realtime'">실시간 도시 현황</a></li>
                    <li class="pushy-link"><a :href="$cp + 'biz'">변화의 은평</a></li>
                    <li class="pushy-link"><a :href="$cp + 'finance'">재정 현황</a></li>
                    <li class="pushy-link"><a :href="$cp + 'indicator'">구정현황</a></li>
                    <li class="pushy-submenu">
                        <button>은평생활</button>
                        <ul>
                            <li class="pushy-link"><a :href="$cp + 'lifemap'">생활지도</a></li>
                            <li class="pushy-link"><a :href="$cp + 'healing'">힐링은평</a></li>
                            <li class="pushy-link"><a :href="$cp + 'waste'">생활폐기물</a></li>
                            <li class="pushy-link"><a :href="$cp + 'commercial'">상권분석</a></li>
                        </ul>
                    </li>
                    <li class="pushy-link"><a :href="$cp + 'opinion'">여론동향</a></li>
                </ul>
        </div>
        </nav>
        <div class="site-overlay"></div>
        <!-- 만족도 조사 팝업 -->
        <div class="research" @click="showPop"></div>
        <div class="research_popup" style="display:none;">
            <div class="rp_tit">
                <p class="tit00">스마트 은평 플랫폼</p>
                <p class="tit02">[{{title}}]</p>
                <p class="tit01">정보가 유용하셨습니까?</p>
            </div>

            <div class="rp_list">
                <ul>
                    <li>
                        <div class="rp_checkbar ic03">
                            <input type="radio" name="ic_chk7" class="ic_chk7" id="research3" value="03">
                            <label for="research3"><i></i>아니오</label>
                        </div>
                    </li>
                    <li>
                        <div class="rp_checkbar ic02">
                            <input type="radio" name="ic_chk7" class="ic_chk7" id="research2" value="02">
                            <label for="research2"><i></i>보통</label>
                        </div>
                    </li>
                    <li>
                        <div class="rp_checkbar ic01">
                            <input type="radio" name="ic_chk7" class="ic_chk7" id="research1" value="01">
                            <label for="research1"><i></i>예</label>
                        </div>
                    </li>
                </ul>
                <div class="comment">
                    <label for="text">
                        <textarea placeholder="의견 남기기" type="textarea" id="research4"></textarea>
                    </label>
                </div>
                <button @click="save" class="btn_submit">저장</button>
            </div>
            <a class="rp_close" @click="close">닫기</a>
        </div>
    </div>
</template>

<script>
import pushy from "@/lib/pushy.js";
import commonConstMixin from "@/store/common.const.mixin.js";
import { $WC } from '@/conf/common.const.js';

export default {
	name: 'GNB',
    props: {
	    title: {
	        type: String,
	        default: "",
	    },
	},
	mounted() {
	    pushy.pushy(jQuery);
        let requestUri = window.location.pathname;

        if(this.getCookie("Survey") === "Y" && this.getCookie(requestUri)){
            $('.research_popup').hide();
            $('.research').hide();
        }
	},

    methods: {
        save(){
            //예, 보통, 아니오를 누르면 해당 값(코드)를 테이블에 넣음
            //예:01 / 보통:02 / 아니오:03
            let radioVal = $('input[name="ic_chk7"]:checked').val();

            if(typeof radioVal === $WC.UNDEF || radioVal === '') {
                alert("만족도 여부를 선택해 주세요.");
                return;
            }
            let opinion = $('#research4').val();
            let formatDay = (new Date()).format('yyyyMMdd');
            let timestamp = new Date().getTime();
            let requestUri = window.location.pathname;
            let data = {'basdtVal': formatDay,'val1':radioVal,'val2': requestUri,'val3': opinion,'val4': timestamp}
            axios.post($WC.apiBaseURL + '/repos/1168', data).then(res => {
                // alert('평가가 반영되었습니다.');
                this.setCookie('Survey','Y', 365);
                this.setCookie(requestUri,'Y',365);

                $('.research_popup').hide();
                $('.research').hide();
            })

	    },

        close() {
            $('.research_popup').hide();
            $('.research').show();
        },
        showPop() {
            $('.research_popup').show();
            $('.research').hide();
        },

        /*쿠키*/
        setCookie(name, value, expiredays) {
            var today = new Date();
            today.setDate(today.getDate() + expiredays);
            document.cookie = name + '=' + escape(value) + '; path=/; expires=' + today.toGMTString() + ';'
        },
        getCookie(name) {
            var cName = name + "=";
            var x = 0;
            while (x <= document.cookie.length) {
                var y = (x+cName.length);
                let endOfCookie;
                if (document.cookie.substring( x, y ) == cName) {
                    if ((endOfCookie=document.cookie.indexOf( ";", y )) == -1)
                        endOfCookie = document.cookie.length;
                    return unescape(document.cookie.substring( y, endOfCookie ));
                }
                x = document.cookie.indexOf( " ", x ) + 1;
                if (x == 0)
                    break;
            }
            return "";
        }
    },
	mixins: [commonConstMixin],
}
</script>
